import { GridColDef } from '@mui/x-data-grid';
import Table from '../custom/Table';
import Title from '../custom/Title';
import DynamicForm from '../forms/DynamicForm';
import { SEARCH_TRANSFER_BLOTTER_FIELDS, TRANSFER_BLOTTER_FIELDS } from '../../Models/BlotterTables';


export const TransfersBlotter = () => {

    const config = SEARCH_TRANSFER_BLOTTER_FIELDS

    const getTransfersBlotterColumns = (): GridColDef<any>[] => {
        let minWidth = 100
        return TRANSFER_BLOTTER_FIELDS.map(inboundField => {
            switch (inboundField.id) {
                case "sreBusinessUnit":
                    minWidth = 150
                    break;
                case "transferRefNo":
                    minWidth = 150
                    break;
                case "transactionDate":
                    minWidth = 150
                    break;
                case "executionDate":
                    minWidth = 150
                    break;
                case "dgTxnRefNo":
                    minWidth = 180
                    break;
                case "paymentPartner":
                    minWidth = 160
                    break;

                default:
                    minWidth = 100
                    break;
            }

            return {
                field: inboundField.id,
                headerName: inboundField.label,
                minWidth
            }
        })
    }

    const PaymentBlotterRows = [{ id: 1 }]
    const submitHandler = (data: any): any => {
    }
    return (
        <div style={{ padding: '0 10px' }}>
            <div style={{ borderBottom: '1px solid #d8d8d8' }}>
                <Title style={{ textAlign: 'left', margin: '20px 10px 10px 10px', color: '#7f7d76' }}>Transfer Blotter</Title>
            </div>
            <div style={{ padding: '20px 0px' }}>
                <DynamicForm config={config} onSubmit={submitHandler} submitText='Search' onCancel={() => { }} cancelText='Clear Filter' />
            </div>
            <Table columns={getTransfersBlotterColumns()} rows={PaymentBlotterRows} />
        </div>
    )
}
